import { render } from "./CustomerManage.vue?vue&type=template&id=3a254a76&scoped=true"
import script from "./CustomerManage.vue?vue&type=script&lang=js"
export * from "./CustomerManage.vue?vue&type=script&lang=js"

import "./CustomerManage.vue?vue&type=style&index=0&id=3a254a76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a254a76"]])

export default __exports__